
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/site/templates",
      function () {
        return require("private-next-pages/site/templates/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/site/templates"])
      });
    }
  